import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import ArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { compose } from "recompose";
import {
  generateQuickFilterString,
  clearFilter,
} from "../../../../common/filterUtilities";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import MergeObjects from "lodash/merge";
import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";
import FilterContainer from "./FilterContainer";

const styles = (theme) => ({
  container: {
    width: "100%",
    padding: "0px 8px 8px 8px",
    boxSizing: "border-box",
    alignSelf: "stretch",
    zIndex: 21,
    height: "calc(100% - 85px)",
  },
  headerPanelcontainer: {
    transform: "rotate(90deg)",
    transformOrigin: "left",
    paddingBottom: 40,
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    width: "max-content",
    color: theme.HeaderSelectedText,
    cursor: "pointer",
  },
  filterListContainer: {
    overflowY: "auto",
    boxSizing: "border-box",
    clear: "both",
    width: "100%",
    paddingTop: 0,
    height: "100%",
  },
  title: {
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  containerAction: {
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    fontWeight: 600,
    float: "right",
    cursor: "pointer",
    padding: "12px 16px 12px 0",
    lineHeight: "20px",
    minWidth: 20,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  filterGroupItem: {
    cursor: "pointer",
    padding: "5px 0px",
  },
  filterGroupTextRoot: {
    padding: 0,
    userSelect: "none",
  },
  filterGroupText: {
    fontSize: theme.textFontSize,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  dotIcon: {
    fontSize: 8,
  },
  listItemIcon: {
    marginRight: 8,
  },
  toggleButtonGroupRoot: {
    paddingLeft: 8,
    paddingBottom: 8,
    borderCollapse: "collapse",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    boxSizing: "border-box",
    overflow: "visible",
    "& $toggleButtonRoot": {
      margin: 0,
      minWidth: 90,
      maxWidth: "max-content",
      borderCollapse: "collapse",
      borderRadius: "initial !important",
    },
  },
  toggleButtonLabel: {
    lineHeight: "20px",
    whiteSpace: "nowrap",
  },
  toggleButtonRoot: {
    padding: "0px 8px",
    fontSize: theme.textFontSize,
    maxHeight: 26,
    textTransform: "none",
    marginLeft: 8,
    marginBottom: 8,
    border: `1px solid ${theme.gridIconBorderColor}`,
    backgroundColor: "transparent",
    color: theme.gridTextColor,
    borderRadius: "2px !important",
    boxSizing: "border-box",
    "&:hover": {
      border: `1px solid ${theme.HeaderSelectedText}`,
      color: theme.HeaderSelectedText,
      backgroundColor: "transparent",
    },
  },
  toggleButtonSelected: {
    backgroundColor: `${theme.HeaderSelectedText} !important`,
    border: `1px solid ${theme.HeaderSelectedText}`,
    color: `white !important`,
  },
  toggleButtonDisabled: {
    backgroundColor: theme.iconColor,
    color: "black",
    cursor: "not-allowed",
  },
  filtersContainer: {
    padding: 5,
    paddingLeft: 16,
    width: "100%",
    boxSizing: "border-box",
  },
  filterIcon: {
    paddingRight: 4,
    marginLeft: -2,
  },
  footer: {
    height: 35,
    fontSize: theme.textFontSize,
    padding: 5,
    backgroundColor: "rgb(0,0,0,0.04)",
    boxSizing: "border-box",
    cursor: "pointer",
    position: "absolute",
    width: "100%",
    bottom: 0,
    color: theme.TextColor,
    display: "inline-flex",
    borderTop: `1px solid ${theme.AppBGColor}`,
    alignSelf: "flex-end",
  },
  footerIcon: {
    verticalAlign: "middle",
    height: "100%",
    padding: "0 4px",
  },
  footerText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "24px",
    color: theme.TextColor,
    width: "100%",
  },
  collapseContainer: {
    width: "100%",
  },
  headerTitle: {
    display: "inline-block",
    margin: 0,
    fontSize: theme.headerTextFontSize,
    padding: "12px 4px 16px 12px",
    color: theme.HeaderSelectedText,
    lineHeight: "20px",
    minWidth: 20,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  quickFilterContainer: {
    borderRadius: "4px",
    userSelect: "none",
    display: "inline-flex",
    flexDirection: "column",
  },
  message: {
    top: "48%",
    width: "90%",
    textAlign: "center",
    position: "absolute",
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    boxSizing: "border-box",
    marginLeft: "5%",
    padding: 5,
    backgroundColor: theme.loadingBGColor,
  },
  filterApplied: {
    color: theme.iconColor,
  },
  header: {
    alignSelf: "flex-start",
    width: "100%",
    display: "inline-flex",
    justifyContent: "space-between",
  },
});

class TrailersGridFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterObject: {},
      quickFilterIsVisible: true,
      isLoading: false,
      filter: "",
    };
    this.initialWidth = this.props.glContainer.width;
  }
  componentDidMount() {
    this.props.glEventHub.on(
      "toggleQuickFilterVisibility",
      this.props.toggleQuickFilterVisibility
    );
    this._isComponentMounted = true;

    this.setState({
      isLoading: true,
      filterObject: {},
    });
    getDataWithQueryString(
      "GetDispatchFilter",
      `filterName=TrailerFilter&terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then(
      (response) => {
        if (this._isComponentMounted) {
          if (response.status === 200) {
            const filterGroupStates = {};
            let filterObject = {};
            response.data.forEach((filter) => {
              if (filter.filterJson) {
                filterObject = MergeObjects(
                  JSON.parse(filter.filterJson),
                  filterObject
                );
              }
            });
            // Defualt keep open all filter groups
            if (filterObject.filterGroups) {
              Object.keys(filterObject.filterGroups).forEach(
                (key) => (filterGroupStates[`${key}_isOpen`] = true)
              );
            }

            this.setState(
              {
                ...filterGroupStates,
                filterObject,
                isLoading: false,
              },
              this.updateFilter()
            );
          } else {
            this.setState(
              {
                filterObject: null,
                isLoading: false,
              },
              this.updateFilter()
            );
          }
        }
      },
      (error) => {
        if (this._isComponentMounted) {
          this.setState(
            {
              filterObject: null,
              isLoading: false,
            },
            this.updateFilter()
          );
        }
      }
    );
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      "toggleQuickFilterVisibility",
      this.props.toggleQuickFilterVisibility
    );
    this.props.glEventHub.emit(
      "UpdateDispatchTrailerQuickFilter",
      appConstants.EMPTY_STRING
    );
    this._isComponentMounted = false;
  }

  // handles hide/collapse for each filter group
  toggleFilterGroupVisibility = ({ groupKey }) => {
    this.setState((state) => ({
      [`${groupKey}_isOpen`]: !state[`${groupKey}_isOpen`],
    }));
  };

  // Render toggle button for button filter and have a handler to change filter applied state
  renderButtonFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = () => {
      filter.isApplied = !filter.isApplied;
      this.updateFilter();
    };
    return (
      <ToggleButton
        key={filter.label}
        selected={filter.isApplied}
        value="filter"
        disabled={filter.isDisabled}
        title={filter.description}
        classes={{
          root: classes.toggleButtonRoot,
          disabled: classes.toggleButtonDisabled,
          selected: classes.toggleButtonSelected,
          label: classes.toggleButtonLabel,
        }}
        onClick={filterChange}
      >
        {filter.label}
      </ToggleButton>
    );
  };

  // Render toggle buttons for toggle filter and have a handler to change filter applied state
  renderSwitchFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = (event, value) => {
      const currentOption = { ...value };
      filter.options.map((option) => {
        if (option.label === currentOption.label) {
          option.isApplied = !option.isApplied;
        } else if (!currentOption.isApplied && option.isApplied) {
          option.isApplied = !option.isApplied;
        }
      });
      this.updateFilter();
    };
    return (
      <ToggleButtonGroup
        exclusive
        key={filter.options.map((option) => option.label).join("_")}
        classes={{ root: classes.toggleButtonGroupRoot }}
        onChange={filterChange}
      >
        {filter.options.map((option) => (
          <ToggleButton
            key={option.label}
            selected={option.isApplied}
            disabled={option.isDisabled}
            title={option.description}
            value={option}
            classes={{
              root: classes.toggleButtonRoot,
              disabled: classes.toggleButtonDisabled,
              selected: classes.toggleButtonSelected,
              label: classes.toggleButtonLabel,
            }}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };

  renderFilterItem = (filter) => {
    switch (filter.actionType) {
      case "switch":
        return this.renderSwitchFilter(filter);
      case "select":
        return this.renderDropdown(filter);
      case "filter":
      default:
        return this.renderButtonFilter(filter);
    }
  };

  // Returns true if any individual filter within a group is Active
  isFilterGroupActive = (filterGroup) => {
    return filterGroup.filters.find((filter) => {
      if (filter.actionType === "switch") {
        return filter.options.find((option) => option.isApplied);
      } else {
        return filter.isApplied;
      }
    });
  };

  // Update the filter string in store based on active filters, which will trigger filter for shipments data
  updateFilter = () => {
    let quickFilterString = appConstants.EMPTY_STRING;
    if (this.state.filterObject) {
      quickFilterString = generateQuickFilterString(
        this.state.filterObject,
        this.props.userData.userProfile.planDate
      );
      this.setState((state) => ({
        filterObject: state.filterObject,
      }));
    }
    this.props.glEventHub.emit(
      "UpdateDispatchTrailerQuickFilter",
      quickFilterString
    );
    const userProfile = this.props.userData.userProfile;
      trackEvent("TrailersGridFilter", userProfile, {
        quickFilter: quickFilterString,
      });
  };

  // removes all active filters
  onClear = () => {
    if (this.state.filterObject) {
      this.setState((state) => ({
        filterObject: clearFilter(state.filterObject),
      }));
      this.props.glEventHub.emit(
        "UpdateDispatchTrailerQuickFilter",
        appConstants.EMPTY_STRING
      );
    }
  };

  isAnyFilterApplied = () => {
    return (
      Object.keys(this.state.filterObject.filterGroups || {})
        .map((key) => {
          return this.isFilterGroupActive(
            this.state.filterObject.filterGroups[key]
          );
        })
        .filter((isActive) => isActive).length > 0
    );
  };

  render() {
    const { classes } = this.props;
    const { filterGroups } = this.state.filterObject || {};
    this.props.glContainer
      .getElement()
      .addClass(this.props.classes.quickFilterContainer);
    return this.props.quickFilterIsVisible ? (
      <Fragment>
        <header className={classes.header} data-automationid="quick-filter">
          <h3 className={classes.headerTitle}> Quick Filters </h3>
          <span className={classes.containerAction} onClick={this.onClear}>
            Clear All
          </span>
        </header>
        <FilterContainer
          classes={classes}
          toggleFilterGroupVisibility={this.toggleFilterGroupVisibility}
          isFilterGroupActive={this.isFilterGroupActive}
          renderFilterItem={this.renderFilterItem}
          filterObject={this.state.filterObject}
          filterGroups={filterGroups}
          isLoading={this.state.isLoading}
          {...this.state}
        />
        <footer
          className={classes.footer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          <ArrowLeft classes={{ root: classes.footerIcon }} />
          <div className={classes.footerText}>Hide Quick Filters</div>
        </footer>
      </Fragment>
    ) : (
      <Fragment>
        <div
          className={classes.headerPanelcontainer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          Quick Filters
          {this.isAnyFilterApplied() && (
            <span className={classes.filterApplied}>- Filter Applied</span>
          )}
        </div>
        <footer
          className={classes.footer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          <Tooltip delay={500} title={"Show Quick Filters"}>
            <ArrowRight classes={{ root: classes.footerIcon }} />
          </Tooltip>
        </footer>
      </Fragment>
    );
  }
}
export default compose(withStyles(styles), withUserProfile)(TrailersGridFilter);
